import React from 'react';
import '../UploadForm.css';
import GeneralTooltip from '../common/GeneralTooltip.js';
import SvgIcon from '../common/SvgIcon';
import ExitIcon3 from '../../assets/icons/close_icon4.svg';

function KeywordsList({ editableKeywords, rankedResumes, newKeywordsMap, onRemoveKeyword }) {
  if (!Array.isArray(editableKeywords) || !Array.isArray(rankedResumes)) {
    return <p className="no-keywords-message">No keywords available</p>;
  }

  const getDisplayName = (filename) => {
    if (!filename) return '';
    const lastDotIndex = filename.lastIndexOf('.');
    const secondLastDotIndex = filename.lastIndexOf('.', lastDotIndex - 1);
    return secondLastDotIndex === -1 ? filename.substring(0, lastDotIndex) : filename.substring(0, secondLastDotIndex);
  };

  return (
    <div className="keywords-container-summary">
      {editableKeywords
        .filter((kw) => typeof kw === 'string')
        .sort((a, b) => a.localeCompare(b))
        .map((keyword, idx) => {
          const isMatched = rankedResumes.some((resume) => Array.isArray(resume.matching_keywords) && resume.matching_keywords.includes(keyword));
          const matchedResumes = rankedResumes.filter((resume) => Array.isArray(resume.matching_keywords) && resume.matching_keywords.includes(keyword));
          const isNew = newKeywordsMap && newKeywordsMap[keyword] !== undefined;
          return (
            <div key={`${keyword}-${idx}`} className={`keyword-tag-container ${isMatched ? 'matched' : 'unmatched'}`} onClick={!isMatched ? () => onRemoveKeyword && onRemoveKeyword(keyword) : undefined}>
              {isMatched ? (
                <GeneralTooltip
                  content={
                    <div style={{ padding: '4px' }}>
                      {matchedResumes.map((resume) => (
                        <div key={resume.label}>
                          {resume.label}: {getDisplayName(resume.filename)}
                        </div>
                      ))}
                    </div>
                  }
                  position="top"
                  delay={150}
                  verticalOffset={9}
                  triggerClassName={'keyword-tag-container'}
                >
                  <span className={`keyword-tag matched`}>{keyword}</span>
                </GeneralTooltip>
              ) : (
                <span className={`keyword-tag unmatched`}>{keyword}</span>
              )}
              {isNew && (
                <span className="keyword-new-icon">
                  <p>NEW</p>
                </span>
              )}
              {!isMatched && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveKeyword && onRemoveKeyword(keyword);
                  }}
                  className="keyword-remove-button"
                >
                  <SvgIcon src={ExitIcon3} color="#ddd" hoverColor="#6e41c1" size="18px" className="exit-icon" />
                </button>
              )}
            </div>
          );
        })}
    </div>
  );
}

export default KeywordsList;


